import { useState } from '@frontend/react';
import { Button, PhoneNumberInput, Text, YStack } from '@frontend/web-react';

import { PROFILE_WIZARD_STEP_CONFIGS } from '../ProfileWizardCard.constants';
import { PROFILE_WIZARD_STEP } from '../ProfileWizardCard.types';

const STEP_CONFIG = PROFILE_WIZARD_STEP_CONFIGS.find((c) => c.step === PROFILE_WIZARD_STEP.phoneNumber)!;

type PhoneNumberStepProps = {
  initialValue: MaybeUndefined<string>;
  isSubmitting: boolean;
  onSubmit: (phoneNumber: string) => void;
};

export const PhoneNumberStep = ({ initialValue, isSubmitting, onSubmit }: PhoneNumberStepProps) => {
  const [phoneNumber, setPhoneNumber] = useState(initialValue ?? '');
  const isValid = phoneNumber.length >= 10;

  return (
    <YStack gapY="md">
      <YStack gapY="xs">
        <Text type="h4">{STEP_CONFIG.title}</Text>
        <Text color="secondary" type="p-sm">
          {STEP_CONFIG.description}
        </Text>
      </YStack>
      <PhoneNumberInput label="" onChange={setPhoneNumber} value={phoneNumber} />
      <Button
        disabled={!isValid}
        fullWidth
        isLoading={isSubmitting}
        label={isValid ? 'Update' : 'Continue'}
        onClick={() => onSubmit(phoneNumber)}
        size="lg"
        variant="primary"
      />
    </YStack>
  );
};
